import './App/styles/BlurOverlay.scss'

const BlurOverlay = () => <div className="blur-overlay" />

export default BlurOverlay
